
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { ImageIcon, Trash2, AlertTriangle } from 'lucide-react';

interface ProductMediaPreviewProps {
  imageUrl: string;
  name: string;
  setImageUrl: (url: string) => void;
  isPreview?: boolean;
  isDataUrl?: boolean;
}

const ProductMediaPreview = ({ 
  imageUrl, 
  name, 
  setImageUrl, 
  isPreview = false,
  isDataUrl = false
}: ProductMediaPreviewProps) => {
  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    console.error(`Erreur de chargement de l'image: ${imageUrl.substring(0, 50)}...`);
    setImageError(true);
  };

  // Si pas d'URL ou erreur de chargement, afficher un placeholder
  if (!imageUrl || imageError) {
    return (
      <div className="flex flex-col items-center justify-center py-12 border border-gray-200 rounded-md h-64">
        <ImageIcon className="h-12 w-12 text-gray-400 mb-2" />
        <p className="text-sm text-gray-500 mb-2">
          {imageError ? "Impossible de charger l'image" : "Ajoutez une image pour votre produit"}
        </p>
      </div>
    );
  }

  return (
    <div className="relative group rounded-md overflow-hidden border border-gray-200 h-64">
      <img 
        src={imageUrl} 
        alt={name} 
        className="w-full h-full object-cover"
        onError={handleImageError}
      />
      
      <div className="absolute top-0 right-0 flex">
        {isPreview && (
          <div className="bg-amber-500 text-white text-xs px-2 py-1">
            Aperçu
          </div>
        )}
        {isDataUrl && (
          <div className="bg-blue-500 text-white text-xs px-2 py-1 flex items-center">
            <AlertTriangle className="h-3 w-3 mr-1" />
            Local
          </div>
        )}
      </div>
      
      <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 flex items-center justify-center transition-opacity duration-200 opacity-0 group-hover:opacity-100">
        <Button 
          variant="destructive" 
          size="sm"
          onClick={() => setImageUrl('')}
          className="opacity-0 group-hover:opacity-100 transition-opacity duration-200"
        >
          <Trash2 className="h-4 w-4 mr-1" />
          Supprimer
        </Button>
      </div>
    </div>
  );
};

export default ProductMediaPreview;
